/**
 * @file Landing Form
 */

import debounce from 'just-debounce';

/**
 * Landing Form component
 */
const vLandingForm = () => {
	const landingForm = document.querySelector( '.v-landing-form' );

	if ( ! landingForm ) {
		return;
	}

	const slider = landingForm.querySelector( '.v-landing-form__slider-input' );

	if ( ! slider ) {
		return;
	}

	const ticks       = landingForm.querySelectorAll( '.v-landing-form__slider-tick' );
	const ranges      = landingForm.querySelector( '.v-landing-form__range-list' );
	const scoreLabel  = landingForm.querySelector( '.v-landing-form__slider-label-text' );
	const arrow       = landingForm.querySelector( '.v-landing-form__slider-arrow' );
	const sliderField = landingForm.querySelector( '.v-landing-form__field-slider' );
	const form        = landingForm.querySelector( '.v-landing-form__form' );
	const checks      = landingForm.querySelectorAll( '.v-landing-form__checkbox-original' );
	const dataLayer   = window.dataLayer || [];

	/**
	 * Validates that options are selected
	 * for the Identity and Borrow sections of the form
	 *
	 * @return {boolean} Whether or not the form is valid
	 */
	const validateSections = () => {
		let isValid  = false;

		if ( ! checks.length ) {
			return isValid;
		}

		let identityChecked = false;
		let borrowChecked   = false;

		[ ...checks ].forEach( ( check ) => {
			if ( ! check.checked ) {
				return;
			}

			if ( check.getAttribute( 'data-section' ) === 'identity' ) {
				identityChecked = true;
			} else {
				borrowChecked = true;
			}
		} );

		isValid = identityChecked && borrowChecked;

		if ( ! isValid ) {
			form.classList.add( 'v-landing-form__form--invalid' );
		}

		return isValid;
	};

	/**
	 * Calculate the arrow position based on slider width
	 */
	const calcArrowPosition = () => {
		const { value }       = slider;
		const roundValue      = Math.round( value );
		const option          = ranges.querySelector( `.v-landing-form__range-option[value="${ roundValue }"]` );
		const minValue        = parseInt( slider.getAttribute( 'min' ) );
		const maxValue        = parseInt( slider.getAttribute( 'max' ) );
		const totalInputWidth = slider.getBoundingClientRect().width;
		const thumbHalfWidth  = 21; // 42px @ this breakpoint

		if ( option ) {
			const label      = option.getAttribute( 'data-label' );
			const id         = option.getAttribute( 'data-id' );
			const activeTick = landingForm.querySelector( `.v-landing-form__slider-tick[data-value="${ roundValue }"]` );
			const thumbLeft  = ( ( ( value - minValue ) / ( maxValue - minValue ) ) * ( ( totalInputWidth - thumbHalfWidth ) - thumbHalfWidth ) ) + thumbHalfWidth;

			[ ...ticks ].forEach( ( tick ) => {
				tick.classList.remove( 'active' );
			} );

			arrow.style.setProperty( '--v-arrow-position', `${ thumbLeft }px` );

			scoreLabel.textContent = label;
			sliderField.value      = id;
			activeTick.classList.add( 'active' );
		}
	};

	slider.addEventListener( 'input', calcArrowPosition );
	window.addEventListener( 'resize', debounce( calcArrowPosition, 250 ) );

	form.addEventListener( 'submit', ( event ) => {
		const validity = validateSections();

		if ( ! validity ) {
			event.preventDefault();
		}

		if ( validity ) {
			const formData   = new FormData( form );
			const isConsumer = document.querySelector( '.v-segment-hero--consumer' );
			const option     = ranges.querySelector( `.v-landing-form__range-option[value="${ formData.get( 'credit-range' ) }"]` );
			const rangeLabel = option.getAttribute( 'data-label' );

			dataLayer.push( {
				event:           'Segment Landing Form',
				vEventCategory:  isConsumer ? 'Consumer' : 'Agent',
				vEventAction:    'Submit',
				vFormIdenity:    formData.get( 'identity[]' ),
				vFormBorrow:     formData.get( 'borrow[]' ),
				vFormScoreRange: rangeLabel,
			} );
		}

		return validity;
	} );

	[ ...checks ].forEach( ( check ) => {
		check.addEventListener( 'change', ( e ) => {
			const { target }    = e;
			const sectionName   = target.getAttribute( 'data-section' );
			const section       = landingForm.querySelector( `.v-landing-form__checks-${ sectionName } .v-landing-form__checkboxes` );
			const sectionChecks = section.querySelectorAll( '.v-landing-form__checkbox-original' );

			form.classList.remove( 'v-landing-form__form--invalid' );
			[ ...sectionChecks ].forEach( ( checkbox ) => {
				if ( checkbox === target ) {
					return;
				}

				checkbox.checked = false;
			} );
		} );
	} );

	setTimeout( calcArrowPosition, 250 );

	// calcArrowPosition();
};

export default vLandingForm;
